import { html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
@safeCustomElement('mdc-reset-password-pop-up')
export class MdcResetPasswordPopUp extends LitElement {
  @property({ type: Boolean }) open = true
  @property({ type: String }) hint =
    'Please check your email for instructions on resetting your password.'
  @property({ type: String, attribute: 'sign-in-button-text' }) signInButtonText = 'Sign In'

  render() {
    return html`
			<mdc-modal .open=${this.open}>
				<mdc-modal-header slot="header">Reset Password</mdc-modal-header>
				<div class="db_reset_password_pop_up__wrapper">
					<mdc-icon name="checkmark-filled"></mdc-icon>
					<p class="db_reset_password_pop_up__hint">${this.hint}</p>
					<mdc-button variant="primary" size="md">${this.signInButtonText}</mdc-button>
				</div>
			</mdc-modal>
		`
  }
}
